import { createStore } from "vuex"
import { vuexOidcCreateStoreModule } from 'vuex-oidc'
import { oidcSettings } from '../oidc'
import createPersistedState from "vuex-persistedstate";
import resultsModule from "./vuex-results-module";
import filtersModule from "./vuex-filters-module";
import phenotypeModule from "./vuex-phenotype-module";
import favouritesModule from "./vuex-favourites-module";
import reservationModule from "./vuex-reservation-module";
import compareModule from "./vuex-compare-module";
import breadcrumbModule from "./vuex-breadcrumb-module";
import cartModule from "./vuex-cart-module";
import fileMTModule from "./vuex-file-mt-module";

export default createStore({
  actions: {
    signOutClear ({ dispatch }) {
      dispatch('phenotypeModule/clearPhenotype')
      dispatch('phenotypeModule/clearReturnRoute')
      dispatch('filtersModule/clearFilters')
      dispatch('filtersModule/clearPhenotypeCompliance')
      dispatch('favouritesModule/clearFavourites')
      dispatch('compareModule/clearCompareList','mtSemen');
      dispatch('compareModule/clearCompareList','mtCell');
      dispatch('cartModule/clearCount');
      dispatch('cartModule/clearCartConfig');
      dispatch('cartModule/clearItems');
      dispatch('cartModule/clearMzItems');
      dispatch('fileMTModule/clearState');
      dispatch('reservationModule/clearChecked');
      dispatch('reservationModule/clearPayment');
      dispatch('reservationModule/clearPaymentReservations');
    }
  },
  modules: {
    oidcStore: vuexOidcCreateStoreModule(
      oidcSettings, 
      { 
        namespaced: true,
        isAuthenticatedBy: 'access_token',
        dispatchEventsOnWindow: true
      },
      {
        accessTokenExpiring: () => { 
          console.log('Access token will expire');
        },
        accessTokenExpired: () => {
          console.log('Access token did expire');
        },
      }
    ),
    resultsModule: resultsModule,
    filtersModule: filtersModule,
    phenotypeModule: phenotypeModule,
    favouritesModule: favouritesModule,
    reservationModule: reservationModule,
    compareModule: compareModule,
    cartModule: cartModule,
    fileMTModule: fileMTModule,
    breadcrumbModule: breadcrumbModule
  },
  plugins: [createPersistedState()]
});